module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: "impress-viewport",
    class: _vm.stepClass,
    style: (_vm.initialRootStyle)
  }, [(!_vm.impressSupported) ? _c('div', [_vm._v("your browser does not support this component")]) : _c('div', {
    staticClass: "impress-canvas",
    style: (_vm.canvasStyle)
  }, [_vm._l((_vm.stepsData), function(step, i) {
    return _c('step', {
      key: i,
      attrs: {
        "step": step,
        "index": i,
        "active": _vm.stepIndex == i
      }
    })
  }), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04d76dc6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./src/components/plugin/impress/Viewport/viewport.pug
// module id = 543
// module chunks = 93